import { EMPTY_OBJECT } from '../../utils/constants'
import { DomApplier } from '../cssFeatures.types'

export const VISUAL_FOCUS_ON_SELECTOR =
	'#SITE_CONTAINER.focus-ring-active :not(.has-custom-focus):not(.ignore-focus):not([tabindex=\\"-1\\"]):focus, #SITE_CONTAINER.focus-ring-active :not(.has-custom-focus):not(.ignore-focus):not([tabindex=\\"-1\\"]):focus ~ .wixSdkShowFocusOnSibling'
export const VISUAL_FOCUS_ON_VALUE = {
	'box-shadow': '0 0 0 1px #ffffff, 0 0 0 3px #116dff !important',
	'z-index': '1',
}

const VISUAL_FOCUS_ON = { [`${VISUAL_FOCUS_ON_SELECTOR}`]: VISUAL_FOCUS_ON_VALUE }

export const accessibilityDomApplier: DomApplier<'accessibility'> = (__, ___, ____, { accessibilityStyle }) => {
	if (!accessibilityStyle) {
		return EMPTY_OBJECT
	}
	return VISUAL_FOCUS_ON
}
